module.exports = __webpack_public_path__ + "img/logo-seat.49a56386.jpg";